module.exports = __webpack_public_path__ + "media/description/description@2x-b9d2bd25.png";